import { useDispatch } from "react-redux";

const UploadConfirmationCompare = ({ setModalOption, modalOption, approvalRef, uploadDoc }: { uploadDoc: Function, approvalRef: any, setModalOption: React.Dispatch<React.SetStateAction<string>>, modalOption: string }) => {
    const dispatch = useDispatch();
    return (
        <div>
            <div className="modal fade" aria-hidden="true" id="upload-doc-compare" ref={approvalRef}>
                <div className="modal-dialog modal-dialog-centered" >
                    <div className="modal-content bg-white">
                        <div className="modal-body pt-4 pb-3 text-center main-msg">
                            <p className='mb-0'>Would you like to share this document with us?</p>
                        </div>
                        <div className="modal-footer justify-content-center border-top-0 pb-4">
                            <button type="button" className="grey-outline-btn mr-3" data-bs-dismiss="modal" onClick={() => {
                                setModalOption("no");
                            }}>No</button>
                            <button type="button" className="outline-icon-btn" data-bs-dismiss="modal" onClick={() => {
                                setModalOption("yes");
                                uploadDoc("compare")
                            }}>Yes</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default UploadConfirmationCompare